/**
 * App variants
 */

export const STORE_APP_VARIANT = 'STORE_APP_VARIANT'

/**
 * User
 */
export const SAVE_USER = 'SAVE_USER'
export const REFRESH_USER = 'REFRESH_USER'
/**
 * Listing
 */
export const STORE_LISTING = 'STORE_LISTING'
/**
 * Modals
 */
export const TOGGLE_CONTACT_MODAL = 'TOGGLE_CONTACT_MODAL'

/**
 * BannerMessage
 */
export const BANNER_MESSAGE_SHOW = 'BANNER_MESSAGE_SHOW'
export const BANNER_MESSAGE_CLOSE = 'BANNER_MESSAGE_CLOSE'

/**
 * Property Analytics
 */
export const SAVE_PROPERTY_ANALYTICS = 'SAVE_PROPERTY_ANALYTICS'
export const SAVE_IS_PROPERTY_REPORT_AVAILABLE =
  'SAVE_IS_PROPERTY_REPORT_AVAILABLE'
export const SAVE_REALTY_TRACK_REPORT = 'SAVE_REALTY_TRACK_REPORT'
export const DISPLAY_SMS_OPTIN_MODAL = 'DISPLAY_SMS_OPTIN_MODAL'

/**
 * Feature Flags
 */
export const STORE_FEATURE_FLAGS = 'STORE_FEATURE_FLAGS'

/**
 * Suggested Offer
 */

export const STORE_SUGGESTED_OFFER = 'STORE_SUGGESTED_OFFER'
